import { render } from "./SettingsImportComponent.vue?vue&type=template&id=6793633d"
import script from "./SettingsImportComponent.vue?vue&type=script&lang=js"
export * from "./SettingsImportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__